import React, { useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
  StyledSecondaryServiceTypography,
} from "../../Theme";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { ReactComponent as PDFIcon } from "../../Icons/Pdf.svg";
import { useNavigate } from "react-router-dom";

const ReviewAccount = () => {
  const navigate = useNavigate();
  const tabs = ["Detail", "Contract"];
  const [selectedTab, setSelectedTab] = useState("Detail");
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };
  return (
    <>
      <Box>
        <BackArrow
          onClick={() => navigate("/sales-overview")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>The Clement Canopy</PrimaryTypography>
        <StyledSecondaryServiceTypography>
          Last Updated: 10 Jul 2023, 13:00
        </StyledSecondaryServiceTypography>
      </Box>
      <Stack
        mt={3}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        px="16px"
        sx={{
          height: "66px",
          backgroundColor: "#FCFCFD",
          border: "1px solid #E5E7EB",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Box
          sx={{
            border: "1px solid #D2D6DB",
            display: "flex",
            borderRadius: "10px",
            overflowX: "scroll",
            "::-webkit-scrollbar": { display: "none" },
          }}
        >
          {tabs.map((value, index) => (
            <Box
              key={index}
              onClick={() => {
                setSelectedTab(value);
              }}
              sx={{
                borderRadius:
                  index === 1
                    ? "0px 8px 8px 0px"
                    : index === 0
                    ? "8px 0px 0px 8px"
                    : "initial",
                borderLeft: index !== 0 ? "1px solid #E5E7EB" : "initial",
                backgroundColor: value == selectedTab ? "#F3F4F6" : "initial",
                width: `${value.length * 12}px`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": { cursor: "pointer" },
              }}
            >
              <Typography
                sx={{
                  color: value === selectedTab ? "#111927" : "#4D5761",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
                textAlign={"center"}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
        <Button
          onClick={() => navigate("/edit-account/1")}
          type="button"
          sx={{ width: "fit-content" }}
          variant="Standard"
        >
          <IconButton sx={{ paddingLeft: "10px" }}>
            {" "}
            <EditIcon width="14px" />
          </IconButton>
          Edit{" "}
        </Button>
      </Stack>
      {selectedTab === "Detail" ? (
        <>
          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            // borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Company Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Company Name
                </StyledSecondaryTypography>
                <TypographyDefault>
                  Singapore Land Group Pte Ltd
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Country</StyledSecondaryTypography>
                <TypographyDefault>Singapore</TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Company Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  sgcontact@singaporeland.com
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contact Number
                </StyledSecondaryTypography>
                <TypographyDefault>+65 9890 4903</TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Company Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  50 Raffles Pl, #21-01/06 Singapore Land Tower, Singapore
                  048623
                </TypographyDefault>
              </Grid>
            </Grid>
          </Box>

          <Box
            // mt={3}
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            // borderRadius="8px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
                // borderRadius: "8px 8px 0 0 ",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Billing Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contract Terms
                </StyledSecondaryTypography>
                <TypographyDefault>3 Years 0 Months</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Commence Date
                </StyledSecondaryTypography>
                <TypographyDefault>01 Aug 204</TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
                <TypographyDefault>Desmond Ng</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Billing Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  finance_sg@singaporeland.com
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Corporate Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  50 Raffles Pl, #21-01/06 Singapore Land Tower, Singapore
                  048623
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contact Number
                </StyledSecondaryTypography>
                <TypographyDefault>+65 9890 4903</TypographyDefault>
              </Grid>
            </Grid>
          </Box>

          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Project Information</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Project Title
                </StyledSecondaryTypography>
                <TypographyDefault>The Clement Canopy</TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Type</StyledSecondaryTypography>
                <TypographyDefault>Residential</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  No. of Units
                </StyledSecondaryTypography>
                <TypographyDefault>505</TypographyDefault>;
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Address</StyledSecondaryTypography>
                <TypographyDefault>
                  16 Clementi Ave 1, Singapore 129960
                </TypographyDefault>
              </Grid>

              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>contact@clementcanopy.sg</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contact Number
                </StyledSecondaryTypography>
                <TypographyDefault>+65 9050 9503</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Country</StyledSecondaryTypography>
                <TypographyDefault>Singapore</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>City</StyledSecondaryTypography>
                <TypographyDefault>Singapore</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Postal Code
                </StyledSecondaryTypography>
                <TypographyDefault>129960</TypographyDefault>
              </Grid>
            </Grid>
          </Box>

          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Administrator Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
                <TypographyDefault>Xiong Liang</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  xiongliang@singaporeland.com
                </TypographyDefault>
              </Grid>
            </Grid>
          </Box>
          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px"
          >
            <Stack
              direction="row"
              alignItems="center"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Onboarded by</SecondaryTypography>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Client Lead
                </StyledSecondaryTypography>
                <TypographyDefault>Keynes yeo</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Email</StyledSecondaryTypography>
                <TypographyDefault>keynesyeo@loby.tech</TypographyDefault>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        <Box sx={{ backgroundColor: "white", padding: "30px 16px 30px 16px" }}>
          <SecondaryTypography>Contract</SecondaryTypography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              p: 2,
              mt: 2,
              background: "#FFFFFF",
            }}
          >
            <Stack direction="row">
              <PDFIcon style={{ marginRight: "12px" }} />
              <Stack direction="column">
                <StyledSecondaryTypography>
                  [SIGNED] Clement_Canopy_2024.pdf
                </StyledSecondaryTypography>
                <StyledSecondaryTypography>2MB</StyledSecondaryTypography>
              </Stack>
            </Stack>
            <Button variant="outlined">View</Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ReviewAccount;
